import { useRegisterSW } from 'virtual:pwa-register/react'

/// Aviso de versão nova.
///
/// O service worker está em `registerType: 'prompt'` de propósito: trocar o código
/// do aplicativo no meio de uma inspeção é inaceitável — o inspetor está com a mão
/// no formulário, às vezes em cima de um andaime. A versão nova instala em segundo
/// plano e **espera**.
///
/// O que faltava era isto: sem ninguém para avisar e mandar ativar, a versão nova
/// esperava para sempre. O aparelho baixava o código novo e continuava rodando o
/// velho, publicação após publicação, sem nenhum sinal na tela.
///
/// O trabalho não corre risco na troca: as respostas moram no IndexedDB, gravadas
/// 600 ms após a última tecla e de novo ao sair da tela. O recarregamento não é
/// automático mesmo assim — quem decide a hora é quem está usando.

export function AvisoAtualizacao() {
  const {
    needRefresh: [precisaAtualizar, setPrecisaAtualizar],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_url, registro) {
      // Procura versão nova a cada hora com o app aberto. Sem isto, só um
      // fechar-e-abrir descobriria a atualização.
      if (registro) setInterval(() => void registro.update(), 60 * 60 * 1000)
    },
  })

  if (!precisaAtualizar) return null

  return (
    <div className="bg-limao py-2 text-sm text-marinho-900">
      <div className="largura flex items-center gap-3">
        <span className="font-semibold">Nova versão disponível</span>
        <span className="hidden text-xs sm:inline">
          Suas inspeções estão salvas e continuam aqui depois de atualizar.
        </span>
        <button
          onClick={() => void updateServiceWorker(true)}
          className="ml-auto shrink-0 rounded-md bg-marinho px-3 py-1 font-semibold text-white"
        >
          Atualizar
        </button>
        <button
          onClick={() => setPrecisaAtualizar(false)}
          className="shrink-0 text-xs underline"
          aria-label="Adiar a atualização"
        >
          Depois
        </button>
      </div>
    </div>
  )
}
